export default "__VITE_ASSET__b6ac0337__"